/**
 * REQ-20260421011 客戶釘選 React Query hooks。
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { ApiSuccess } from '@app/shared';
import { apiClient } from '../../lib/api-client';

export interface PinnedCustomerBrief {
  id: number;
  cCode: string | null;
  simpleName: string;
  fullName: string;
  mobile: string | null;
  pinnedAt: string;
}

export function usePinnedCustomers() {
  return useQuery({
    queryKey: ['pinned-customers'],
    queryFn: async (): Promise<PinnedCustomerBrief[]> => {
      const res = await apiClient.get<ApiSuccess<PinnedCustomerBrief[]>>(
        '/me/pinned-customers',
      );
      return res.data.data;
    },
  });
}

export function useIsPinned(customerId: number | undefined) {
  return useQuery({
    queryKey: ['customer-pin', customerId],
    enabled: customerId != null,
    queryFn: async (): Promise<boolean> => {
      const res = await apiClient.get<ApiSuccess<{ pinned: boolean }>>(
        `/customers/${customerId}/pin`,
      );
      return res.data.data.pinned;
    },
  });
}

export function useTogglePin(customerId: number | undefined) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (nextPinned: boolean): Promise<void> => {
      if (customerId == null) return;
      if (nextPinned) {
        await apiClient.post(`/customers/${customerId}/pin`);
      } else {
        await apiClient.delete(`/customers/${customerId}/pin`);
      }
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['customer-pin', customerId] });
      void qc.invalidateQueries({ queryKey: ['pinned-customers'] });
    },
  });
}
